import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

/** Sums vendor_bill line items into the header items_total / tax_amount /
 * total_amount fields, the same way GrandTotalsWatcher does for the other
 * document types (field names differ here, so it's a small dedicated watcher
 * rather than a reuse of GrandTotalsWatcher). */
export const VendorBillTotalsWatcher = () => {
    const { setValue } = useFormContext();
    const items = useWatch({ name: 'items' }) || [];
    const itemsStr = JSON.stringify(items);

    useEffect(() => {
        if (!Array.isArray(items)) return;

        let itemsTotal = 0;
        let taxTotal = 0;

        items.forEach((item: any) => {
            const qty = Number(item.quantity) || 0;
            const price = Number(item.unit_price) || 0;
            itemsTotal += qty * price;
            taxTotal += Number(item.tax_amount) || 0;
        });

        itemsTotal = Math.round(itemsTotal * 100) / 100;
        taxTotal = Math.round(taxTotal * 100) / 100;
        const totalAmount = Math.round((itemsTotal + taxTotal) * 100) / 100;

        setValue('items_total', itemsTotal, { shouldDirty: true });
        setValue('tax_amount', taxTotal, { shouldDirty: true });
        setValue('total_amount', totalAmount, { shouldDirty: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsStr, setValue]);

    return null;
};
